import { render } from "./LoadingStart.vue?vue&type=template&id=3d7c8baf"
import script from "./LoadingStart.vue?vue&type=script&lang=js"
export * from "./LoadingStart.vue?vue&type=script&lang=js"

import "./LoadingStart.vue?vue&type=style&index=0&id=3d7c8baf&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__